module.exports = __webpack_public_path__ + "static/media/info.acac4580.svg";